<template>


    <div style="padding: 5px 20px;" class="drawer-wrap">
<!--                <el-button type="success" :disabled="editIs==0" size="mini" @click="addQueeter">初始化</el-button>-->
                <el-button type="danger" :disabled="editIs==0" size="mini" @click="formSubmit('all')">保存</el-button>
                <span style="color: #e50011">(*选择月为必填项)</span>

                <el-table :data="quesList" :span-method="objectSpanMethod" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                    <!--<el-table-column type="index" label="序号" width="50"></el-table-column>-->



                    <el-table-column label="重点板块">
                        <template slot-scope="scope">
                            <el-input type="textarea"
                                      autosize
                                      :disabled="true"
                                      v-model="scope.row.kpi" size="mini" maxlength="500"  @change="formSubmit"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="O-目标" >
                        <template slot-scope="scope">
                            <el-input type="textarea"

                                      autosize
                                      :disabled="scope.row.isEdit==0"
                                      v-model="scope.row.formula" size="mini" maxlength="500" @change="formSubmit"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="关键结果"  >
                        <template slot-scope="scope">
                            <el-input type="textarea"
                                      autosize
                                      :disabled="scope.row.isEdit==0"
                                      v-model="scope.row.leaderKpi" size="mini" maxlength="500" @change="formSubmit"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="策略路径">
                        <template slot-scope="scope">
                            <el-input type="textarea"
                                      autosize
                                      :disabled="scope.row.isEdit==0"
                                      v-model="scope.row.leaderFormula" size="mini" maxlength="500" @change="formSubmit"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column :label="tableTitle.month">
                        <el-table-column :label="tableTitle.W1">
                            <template slot-scope="scope">
                                <el-input type="textarea"
                                          autosize
                                          :disabled="scope.row.isEdit==0"
                                          v-model="scope.row.week1" size="mini" maxlength="500" @change="formSubmit"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column :label="tableTitle.W2">
                            <template slot-scope="scope">
                                <el-input type="textarea"
                                          autosize
                                          :disabled="scope.row.isEdit==0"
                                          v-model="scope.row.week2" size="mini" maxlength="500" @change="formSubmit"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column :label="tableTitle.W3">
                            <template slot-scope="scope">
                                <el-input type="textarea"
                                          autosize
                                          :disabled="scope.row.isEdit==0"
                                          v-model="scope.row.week3" size="mini" maxlength="500" @change="formSubmit"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column :label="tableTitle.W4">
                            <template slot-scope="scope">
                                <el-input type="textarea"
                                          autosize
                                          :disabled="scope.row.isEdit==0"
                                          v-model="scope.row.week4" size="mini" maxlength="500" @change="formSubmit"></el-input>
                            </template>
                        </el-table-column>
                        <template v-if="tableTitle.weeks>=5">
                            <el-table-column :label="tableTitle.W5">
                                <template slot-scope="scope">
                                    <el-input type="textarea"
                                              autosize
                                              :disabled="scope.row.isEdit==0"
                                              v-model="scope.row.week5" size="mini" maxlength="500" @change="formSubmit"></el-input>
                                </template>
                            </el-table-column>
                        </template>

                    </el-table-column>

                    <el-table-column label="操作" fixed="right" width="150" >
                        <template slot-scope="scope">
                            <el-button :disabled="scope.row.isEdit==0" type="danger" size="mini" @click="addKpi(scope.row)">加行</el-button>
                            <el-button :disabled="scope.row.isEdit==0" type="danger" size="mini" @click="delKpi(scope.row.id)">删行</el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog
                :title="dialogType==2?'评论原因':'点赞原因'"
                :visible.sync="showDialog"
                width="50%"
                :append-to-body=true
                center
                @close="closeLikeDialog">
            <el-input
                    type="textarea"
                    :rows="2"
                    autosize
                    placeholder="请输入内容"
                    v-model="likeCommitContent" maxlength="5000" show-word-limit>
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :disabled="likeCommitContent.length<=0" @click="cooperativeLike(paperId,periodId)">确 定</el-button>
              </span>
        </el-dialog>
    </div>


</template>

<script>
    //导入 HTTP请求方法
    import {getCustomerList,uploadCooperativeFile,downloadExcelCooperative,importKpi,getKrTableTitle} from '@/api/api';
    import {getRouterPageHash} from '@/api/http';



    //定义组件
    export default {
        data() {
            return {
                quesList:[],

                drawerShow:false,
                editIs:0,
                voitIs:0,
                periodId:'',
                paperId:'',
                fileObjList:[],
                uploadFile:uploadCooperativeFile,
                userAllList:[],
                selectUserList1:[],
                selectUserList:[],
                currentSelectIndex:-1,
                showDialog:false,
                dialogType:1,
                likeCommitContent:'',
                isLeader:0,
                importKpiParam:importKpi,
                title:'',
                updateFlag:0,
                paperpage:this.param,
                classId:0,
                period:this.param.period,
                tableTitle:{"month":"2020.01","W1":"W1(202001)"},

            }
        },
        computed:{

        },
        //挂载时候执行
        mounted() {
            //var currMonth=(new Date().getMonth() + 1);
            //this.period=Math.floor( ( currMonth % 3 == 0 ? ( currMonth / 3 ) : ( currMonth / 3 + 1 ) ) )-1;
            this.getKrTableTitle(this.paperpage);
            this.getCooperativeQues(this.paperpage)
        },
        watch: {
            param(val){
                this.paperpage=val;
                this.period=val.period;
                this.getCooperativeQues(this.paperpage)
            }
        },
        props:['param'],
        methods: {
            //定义查询方法

            getCooperativeQues(obj) {
                if(obj!=null&&obj!=undefined){
                    this.drawerShow = true;
                    this.voitIs = obj.isVote;
                    this.periodId = obj.periodId;
                    this.paperId = obj.id;
                    this.isLeader = obj.isLeader;
                    this.classId=obj.questionClassId;
                    this.editIs=obj.isEdit;
                    this.title=obj.questionClassName+" (标*必填)"+" :【"+obj.userName+"】"+obj.periodName;
                    this.updateFlag=obj.updateFlag;

                }

                this.$store.dispatch('getQuarterKpiQuesInfo',{classId:this.classId,paperId:this.paperId}).then(res=>{
                    console.log(res)
                    this.quesList = res
                })
            },
            addKpi(row){
                this.$store.dispatch('getQuarterKpiQuesIdInfo',{classId:this.classId,paperId:this.paperId,"kpi":row.kpi,"formula":row.formula}).then(res=>{
                    console.log(res)
                    this.quesList=( res);
                })
            },
            getKrTableTitle(obj) {
                if(obj!=null&&obj!=undefined){
                    this.paperId = obj.id;
                }

                this.$store.dispatch('getKrTableTitle',{paperId:this.paperId}).then(res=>{
                    console.log(res)
                    this.tableTitle = res
                })
            },
            // handleSizeChange(val) {
            //     this.formInline.pageSize = val;
            //     this.getCooperativeList()
            // },
            // handleCurrentChange(val) {
            //     this.formInline.currentPage = val;
            //     this.getCooperativeList()
            // },

            addQueeter(){
                let obj = {
                    "id": null,//主键id，在得到kpi的接口中取的，如果没有传null
                    "paperId": this.paperId,//列表页上传过来的
                    "userId": null,//传null
                    "kpi": "",//目标名称
                    "value": 0,//目标价值
                    "formula": "",//计算公式
                    "weight": 0,//权重，点保存时判断所有行是否100%，实时保存时不用判断
                    "leaderKpi": null,//leader确认目标名称
                    "leaderValue": null,//leader确认目标价值
                    "leaderFormula": null,//leader确认计算公式
                    "leaderWeight": null,//leader确认权重
                    "monthKpi": 0,//是否月度评估 1是，0否
                    "isEdit": this.editIs,//
                    "month": null,//月份，传数字，勾选了monthKpi以后选择的月份传这个字段里
                    "factValue": null,//实际价值，暂时传null
                    "factFormula": null,//实际公式，暂时传null
                    "createTime": null,//创建时间，传null
                    "leaderConfirmTime": null,//leader确认时间，传null
                    "factConfirmTime": null,//实际确认时间，传null
                    "week1":null,"week2":null,"week3":null,"week4":null,"week5":null,
                }
                this.$store.dispatch('getQuarterKpiQuesIdInfo',{paperId:this.paperId}).then(res=>{
                    //obj.id = res;
                    this.quesList=(res)
                })

            },
            formSubmit(state){
                let _this = this;
                if(state=='all'){
                    let countW = 0;
                    let countLeaderW = 0;
                    let isLeaderState = 0;
                    let monthS = null
                    this.quesList.forEach(item=>{
                        countW+=item.weight
                        countLeaderW+=item.leaderWeight
                        isLeaderState = item.isLeader
                        monthS = item.month?null:'empty'
                    })
                    let tipsText = isLeaderState==1?parseFloat(countLeaderW).toFixed(2):parseFloat(countW).toFixed(2)
                    // if(isLeaderState==0&&countW!=100||isLeaderState==1&&countLeaderW!=100){
                    //     this.$notify({
                    //         title: '提示',
                    //         message: '权重之和必须是100%,现在的权重之和是'+tipsText,
                    //         type: 'danger'
                    //     });
                    //     return false
                    // }
                    if(monthS == 'empty'){
                        this.$notify({
                            title: '提示',
                            message: '选择月为必填项',
                            type: 'danger'
                        });
                        return false
                    }
                }
                this.$store.dispatch('saveQuarterKpiQuesInfo',{kpiEntityList:JSON.stringify(this.quesList)}).then(res=>{
                    if(state=='all'){
                        //this.drawerShow = false;
                        this.$emit('drawClose','false');
                        //this.getCooperativeList()
                        this.$notify({
                            title: '成功',
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                })
            },
            closeLikeDialog(){
                this.likeCommitContent = ''
            },
            isMonthKpi(val,item){
                console.log(val)
            },
            showCommentDialog(type){
                this.dialogType = type
                this.showDialog = true
            },


            delKpi(id){
                this.$confirm('此操作将删除改行数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('delQuarterKpiQuesInfo',{kpiId:id}).then(res=>{

                        this.getCooperativeQues(null)
                        this.$notify({
                            title: '成功',
                            message: '删除成功',
                            type: 'success'
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });


            },
            targetValueInput(val){
                console.log(arguments)
            },


            updateFlagFun(Id){
                this.$confirm('此操作将清除用户勾选和领导勾选状态, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('updateFinishFlag',{"Id":Id}).then(res=>{
                        this.getCooperativeQues(null)
                        this.$notify({
                            title: '成功',
                            message: '设置成功',
                            type: 'success'
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });


            },
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                //var len=5;//this.quesList.length;

                if (columnIndex === 0||columnIndex === 1) {
                    var _row =(this.flitterData4(this.quesList).one)[rowIndex]
                    console.log(_row);
                    //if (rowIndex % _row === 0) {
                        return {
                            rowspan: _row,
                            colspan:  _row > 0 ? 1 : 0
                        };
                    //} else {
                    //    return {
                    //        rowspan: 0,
                    //        colspan: 0
                    //    };
                    //}
                }
            },
            flitterData4(){
                let spanOneArr = []
                let concatOne = 0
                //let spanOneArr1 = []
                //let concatOne1 = 0
                this.quesList.forEach((item,index)=>{//循环后端查询出来的数据(orderdata)
                    if(index === 0){
                        spanOneArr.push(1)
                    }else{
                        //name 修改
                        if(item.kpi === this.quesList[index - 1].kpi){ //第一列需合并相同内容的字段
                            spanOneArr[concatOne] += 1
                            spanOneArr.push(0)
                        }else{
                            spanOneArr.push(1)
                            concatOne = index
                        }
                        // if(item.formula === this.quesList[index - 1].formula){ //第二列需合并相同内容的判断条件
                        // spanOneArr1[concatOne1] += 1
                        // spanOneArr1.push(0)
                        // }else{
                        // spanOneArr1.push(1)
                        // concatOne1 = index
                        // }
                    }
                })
                return  {
                    one: spanOneArr,
                    //two:spanOneArr1
                }
            },
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" >
    .el-drawer__body{
        overflow-y: scroll;
    }
    .el-textarea__inner{
        min-height: 40px !important;
    }
    .quarter-form{
        .el-input-number{
            width: 100% !important;
        }

    }
    .drawer-wrap{
        .el-table__expanded-cell{
            background: #f5f5f5;
            text-align: left!important;
            padding: 7px 50px;
            .el-select,.el-input,.el-input-number{
                width: 240px;
            }
        }
    }
    .el-drawer__header{
        /*color:#000000;*/
        margin-bottom:10px;
        font-size:20px;
    }

</style>



// WEBPACK FOOTER //
// src/components/cooperative/kr.vue